import React, { useEffect, useState } from 'react';
import {
  TextField,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from '@mui/material';
import { TimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import propTypes from 'prop-types';

const TimePickerModal = ({ open, onClose, selectedDate, onSave, tmpMessage, input }) => {
  const [dateFromModal, setDateFromModal] = useState('');

  useEffect(() => {
    setTimes();
  }, [tmpMessage]);

  const setTimes = () => {
    if (tmpMessage[input.propName]) {
      const date = new Date();
      date.setHours(tmpMessage[input.propName].hh);
      date.setMinutes(tmpMessage[input.propName].mm);
      setDateFromModal(date);
    } else {
      setDateFromModal('');
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle style={{ textAlign: 'center' }}>Seleccionar hora</DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <TimePicker
            label="Cantidad hh y mm"
            value={dateFromModal}
            onChange={(date) => setDateFromModal(date)}
            ampm={false}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="center">
          <Button
            onClick={() => {
              setTimes();
              onClose();
            }}
            style={{ marginRight: 4 }}
          >
            Cerrar
          </Button>
          <Button onClick={() => onSave(dateFromModal)} color="primary">
            Guardar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

TimePickerModal.propTypes = {
  open: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  selectedDate: propTypes.oneOfType([propTypes.instanceOf(Date), propTypes.string]).isRequired,
  onSave: propTypes.func.isRequired,
  tmpMessage: propTypes.object.isRequired,
  input: propTypes.object.isRequired,
};

const TimePickerComponent = ({ setTmpMessage, tmpMessage, input, index, classes }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };
  const handleSave = (date) => {
    setSelectedDate(date);
    setShowModal(false);
  };

  useEffect(() => {
    if (selectedDate !== '') {
      setTmpMessage({
        ...tmpMessage,
        [input.propName]: { hh: selectedDate.getHours(), mm: selectedDate.getMinutes() },
      });
    }
  }, [selectedDate]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginLeft: 'auto',
      }}
    >
      <Button
        key={`${input.propName}${index}`}
        variant="contained"
        color="secondary"
        className={input.isSuccess ? classes.cancelButton : ''}
        sx={{ ml: index !== 0 ? 2 : 0, height: 'fit-content' }}
        onClick={() => {
          setShowModal(true);
        }}
      >
        {input.label}
      </Button>
      <TimePickerModal
        open={showModal}
        onClose={handleClose}
        onSave={handleSave}
        selectedDate={selectedDate}
        tmpMessage={tmpMessage}
        input={input}
      />
    </Box>
  );
};

const Props = {
  setTmpMessage: propTypes.func,
  tmpMessage: propTypes.object,
  input: propTypes.object,
  index: propTypes.number,
  classes: propTypes.object,
};

TimePickerComponent.propTypes = Props;

export default TimePickerComponent;
